import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Background from '../../components/Background/Background'
import FlexSection from '../../components/FlexSection/FlexSection'
import CustomSlider from '../../components/CustomSlider/CustomSlider'
import Image from '../../components/Image/Image'
import Title from '../../components/Title/Title'
import SelectedSex from '../../components/SelectedSex/SelectedSex'

import girlSmall from './girl-small.svg'
import girlMedium from './girl-medium.svg'
import girlLarge from './girl-large.svg'
import boySmall from './boy-small.svg'
import boyMedium from './boy-medium.svg'
import boyLarge from './boy-large.svg'

const CURRENT_STEP_NUMBER = 2
const NEXT_STEP_URL = 'oppleves-det-som-et-problem'

class Age extends Component {
  constructor(props) {
    super(props)
    this.state = {
      age: 5,
    }
    this.onSliderChange = this.onSliderChange.bind(this)
    this.onAfterSliderChange = this.onAfterSliderChange.bind(this)
  }

  componentDidMount() {
    this.props.initStep(CURRENT_STEP_NUMBER, NEXT_STEP_URL)
    this.props.updateScore(10, 3, CURRENT_STEP_NUMBER, this.formatAgeText(5))
  }

  onSliderChange(value) {
    this.setState({ age: value })
  }

  onAfterSliderChange(age, id) {
    let value = age
    if (age >= 6) value += 50
    if (age >= 8) value += 100
    const answerString = this.formatAgeText(age)
    this.props.updateScore(value, id, CURRENT_STEP_NUMBER, answerString)
  }

  formatAgeText = age => (age === 8 ? `${age}+ år` : `${age} år`)

  render() {
    const { selectedSex } = this.props
    const { age } = this.state

    const images = {
      boySmall,
      boyMedium,
      boyLarge,
      girlSmall,
      girlMedium,
      girlLarge,
    }

    return (
      <Background color="#6FABFF">
        <FlexSection>
          <Title>
            Hvor gammel er <SelectedSex selectedSex={selectedSex} />?
          </Title>
          <Image
            className="h-50"
            dynamic
            {...images}
            selectedSex={selectedSex}
            age={age}
          />
          <div className="white primary-font-bold mt3 f3">{this.formatAgeText(age)}</div>
          <div className="flex justify-between ph4 mw7 w-100 mt2 mb2">
            <CustomSlider
              onAfterSliderChange={this.onAfterSliderChange}
              onSliderChange={this.onSliderChange}
              id={1}
              min={5}
              max={8}
              defaultValue={4}
            />
          </div>
        </FlexSection>
      </Background>
    )
  }
}

Age.propTypes = {
  updateScore: PropTypes.func.isRequired,
  selectedSex: PropTypes.string,
}

export default Age



// WEBPACK FOOTER //
// ./src/containers/Age/Age.js